import { Box, FormControlLabel, Switch } from '@mui/material';
import { MultiSelect } from '../MultiSelect';
import { TableFiltersProps } from './EnhancedTable.types';

export function TableFilters({
  filterProps,
  isAuditOfInterest,
  filterByAuditOfInterest,
}: TableFiltersProps) {
  return (
    <Box
      sx={{
        marginTop: '10px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        alignItems: 'center',
        mb: 2,
      }}
    >
      {filterProps &&
        filterProps.map((props) => (
          <Box
            key={props.id}
            sx={{
              width: '330px',
              flex: '0 0 auto',
              order: 1,
            }}
          >
            <MultiSelect
              deferred
              label={props.label}
              options={props.allOptions}
              value={props.selectedOptions}
              onChange={props.setSelectedOptions}
            />
          </Box>
        ))}

      {filterByAuditOfInterest && (
        <Box
          key='audit'
          sx={{
            width: '190px',
            flex: '0 0 auto',
            display: 'flex',
            alignItems: 'center',
            order: 2,
          }}
        >
          <FormControlLabel
            value='start'
            checked={isAuditOfInterest}
            control={<Switch color='primary' />}
            label='Audit of Interest'
            labelPlacement='start'
            onChange={(_, checked) => filterByAuditOfInterest(checked)}
          />
        </Box>
      )}
    </Box>
  );
}
